
import React, { Component } from "react";
import ic_no_data from "../../assets/ic_no_data.svg";
import JobEntity from "../../types/jobEntity.type";


type Props = {
  fullName?: string | null
};

type State = {
  jobEntity: JobEntity[] | null;
}

export default class EmptyPostedDeliveriesView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      jobEntity: null
    };
  }
  render() {
    var content;
    if (this.props.fullName != null) {
      content = <p>We didnt find any posted deliveries for {this.props.fullName}</p>
    } else {
      content = <>
        <img src={ic_no_data} />
        <p>We didnt find any posted deliveries</p>
      </>
    }
    return <>
      <div>
        {content}
      </div>
    </>
  }
}